import { zodResolver } from "@hookform/resolvers/zod";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
import { z } from "zod";
import api from "../../../utils/api";
import Loader from "../../Loader/Loader";
import "./Application__Form.css";
import cancel from "../../../assets/cancel.png";

const applicationTypeSchema = z.object({
  name: z.string().min(1, "Type is required"),
  amount: z
    .number({ invalid_type_error: "Amount is required" })
    .positive("Amount must be greater than 0"),
});

const Application__Form = ({ setDisp }) => {
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: zodResolver(applicationTypeSchema),
  });

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      await api.post("/applications/types", data);
      reset();
      toast.success("Application type added successfully");
      setDisp();
    } catch (error) {
      console.error("error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="advertisment__form_div_open">
      <div className="advertisment__form application__form">
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
          <h2 style={{margin: '0', fontSize: '24px'}}>Add Application Type</h2>
        <button
          type="button"
          className="close-button"
          onClick={() => setDisp()}
          aria-label="Close form"
        >
          <img src={cancel} alt="cancel" />
        </button>

        </div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="advertisment__form_input">
            <label className="input-label">
              <h5>Type:</h5>
              <input
                type="text"
                placeholder="Enter application type"
                {...register("name")}
                className="advertisment__form_input_small"
              />
            </label>
            {errors.name && (
              <p className="error-message">{errors.name.message}</p>
            )}
          </div>

          <div className="advertisment__form_input">
            <label className="input-label">
              <h5>Amount:</h5>
              <input
                type="number"
                step="any"
                placeholder="Enter amount"
                {...register("amount", { valueAsNumber: true })}
                className="advertisment__form_input_small"
              />
            </label>
            {errors.amount && (
              <p className="error-message">{errors.amount.message}</p>
            )}
          </div>

          <div className="button-container">
            {loading ? (
              <Loader small={true} />
            ) : (
              <button className="advertisment__form_button" type="submit">
                <span>Add Application Type</span>
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default Application__Form;
